module.exports = __webpack_public_path__ + "0f6814e22b37d8a6952a83c3dd3a543c.png";